import { apiHolder, apis, } from 'api';
import lodashGet from 'lodash/get';
import { edmOperateVarBeforeSend } from '@web-mail-write/components/SendMail/utils';
const edmApi = apiHolder.api.requireLogicalApi(apis.edmSendBoxApiImpl);
const mailSigApi = apiHolder.api.requireLogicalApi(apis.mailSignatureImplApi);
const mailApi = apiHolder.api.requireLogicalApi(apis.mailApiImpl);
export const buildBasicInputBy = (resp) => {
    let input = {
        req: {
            first: false,
            company: resp.company,
            industry: resp.industry,
            companyIntro: resp.companyIntro,
            productIntros: resp.productIntros,
            language: resp.language,
        },
        name: resp.name,
        createTime: resp.createTime,
        planMode: resp.planMode,
        senderEmail: lodashGet(resp, 'multiHostingInfos.0.mailInfos.0.sendSettingInfo.senderEmail', '') || resp.senderEmail,
        senderEmails: lodashGet(resp, 'multiHostingInfos.0.mailInfos.0.sendSettingInfo.senderEmails', '') || resp.senderEmails,
        setting: {
            sender: lodashGet(resp, 'multiHostingInfos.0.mailInfos.0.sendSettingInfo.sender', '') || resp.sender,
            replyEmail: lodashGet(resp, 'multiHostingInfos.0.mailInfos.0.sendSettingInfo.replyEmail', '') || resp.replyEmail,
        },
        autoRecInfo: lodashGet(resp, 'multiHostingInfos.0.planInfo.autoRecInfo', undefined) || resp.autoRecInfo,
        ruleInfo: resp.ruleInfo,
        items: resp.items,
        pauseUntilTime: resp.pauseUntilTime,
        agentSend: lodashGet(resp, 'multiHostingInfos.0.planInfo.agentSend', undefined),
    };
    if (input.ruleInfo && resp.autoMaxSendLimit) {
        input.ruleInfo.autoMaxSendLimit = resp.autoMaxSendLimit;
    }
    if (input.ruleInfo && resp.manualMaxSendLimit) {
        input.ruleInfo.manualMaxSendLimit = resp.manualMaxSendLimit;
    }
    return input;
};
export const buildAiResultMatrix = (aiResult) => {
    if (!aiResult || aiResult.modify.length === 0) {
        return {};
    }
    let indexMatrix = new Array();
    let valueMatrix = new Array();
    aiResult === null || aiResult === void 0 ? void 0 : aiResult.modify.forEach(item => {
        var _a;
        let innerIndexArray = new Array();
        let innerValueArray = new Array();
        innerIndexArray.push(0);
        innerValueArray.push({
            placeholder: item.placeholder,
            aiSentence: item.originalSentence,
        });
        item.use &&
            ((_a = item.aiSentenceList) === null || _a === void 0 ? void 0 : _a.forEach((innerItem, innerIndex) => {
                if (!innerItem.unSelected) {
                    innerIndexArray.push(innerIndex + 1);
                    innerValueArray.push({
                        placeholder: item.placeholder,
                        aiSentence: innerItem.aiSentence,
                    });
                }
            }));
        indexMatrix.push(innerIndexArray);
        valueMatrix.push(innerValueArray);
    });
    return {
        indexMatrix: buildIndex(indexMatrix),
        valueMatrix: valueMatrix,
    };
};
const buildIndex = (arr) => {
    var ans = new Array();
    dfs(arr.length, 0, arr, new Array(), ans);
    console.log('hanxu buildIndex: ' + ans);
    return ans;
};
const dfs = (n, row, arr, selected, ans) => {
    if (row == n) {
        ans.push([...selected]);
        return;
    }
    for (const value of arr[row]) {
        selected.push(value);
        dfs(n, row + 1, arr, selected, ans);
        selected.pop();
    }
};
export const getVars = (content) => {
    if (!content) {
        return [];
    }
    const doc = new DOMParser().parseFromString(content, 'text/html');
    const ret = {};
    if (doc.body) {
        Array.from(doc.body.querySelectorAll('.mce-lx-var'))
            .map(span => span.textContent)
            .forEach(s => {
            if (s && s.length > 2) {
                if (s.startsWith('#{') && s.endsWith('}')) {
                    ret[s.substring(2, s.length - 1)] = 1;
                }
            }
        });
    }
    return Object.keys(ret);
};
export const combineMailinfoAndAiModify = (mailInfo, basicInput, modify) => {
    let info = mailInfo.contentEditInfo;
    if (!info) {
        return {};
    }
    if (!info.templateParams) {
        info.templateParams = getVars(info.emailContent).join(',');
    }
    delete info.content;
    let roundInfo = {
        edmRoundId: undefined,
        sendSettingInfo: Object.assign({ emailSubjects: [
                {
                    subject: info.subject || '',
                },
            ], senderEmail: basicInput === null || basicInput === void 0 ? void 0 : basicInput.senderEmail, senderEmails: basicInput === null || basicInput === void 0 ? void 0 : basicInput.senderEmails, emailSummary: info === null || info === void 0 ? void 0 : info.emailSummary }, basicInput === null || basicInput === void 0 ? void 0 : basicInput.setting),
        contentEditInfo: Object.assign({}, info),
        multipleContentInfo: (modify === null || modify === void 0 ? void 0 : modify.get(mailInfo.roundIndex || 1)) || mailInfo.multipleContentInfo,
        syncSendEmail: true,
        plan: mailInfo.plan,
    };
    return roundInfo;
};
export const uploadToNos = async (data, deleteSource) => {
    console.log('hanxu- uploadToNos');
    await upload(data.hostingInfo, deleteSource);
};
export const upload = async (info, deleteSource) => {
    var _a, _b;
    if (!info) {
        return;
    }
    let infos = new Array();
    for (let item of info.mailInfos || []) {
        if (deleteSource) {
            item.plan = undefined;
        }
        if (item.contentEditInfo) {
            infos.push(item.contentEditInfo);
        }
        if ((((_a = item.expandHostingMailInfos) === null || _a === void 0 ? void 0 : _a.length) || 0) > 0) {
            let temp = item.expandHostingMailInfos[0].contentEditInfo;
            if (temp && (((_b = temp.emailContent) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0) {
                infos.push(temp);
            }
        }
    }
    await uploadBasicMailInfoToNos(infos, deleteSource);
};
export const uploadBasicMailInfoToNos = async (infos, deleteSource) => {
    for (let item of infos) {
        if (item.emailContent) {
            const resp = await edmApi.emailContentUpload({
                emailContent: edmOperateVarBeforeSend(item.emailContent || ''),
                emailContentId: '',
            });
            item.originalEmailContentId = resp.emailContentId;
        }
        if (deleteSource) {
            item.emailContent = undefined;
            item.content = undefined;
        }
    }
    console.log('hanxu- upload over');
};
export const isAiOn = (plan) => {
    if (!plan) {
        return false;
    }
    if (plan.aiOn) {
        return true;
    }
    return false;
};
export const hasAiModifyContent = (plan) => {
    if (plan === null || plan === void 0 ? void 0 : plan.aiResult) {
        return true;
    }
    return false;
};
const buildPtMailContentImgVarOrg = () => {
    return () => ({
        contentUrlList: [require('./images/contentP.png'), require('./images/contentP2.png'), require('./images/contentP3.png')],
        productPUrl: require('./images/product.png'),
        lastMailUrl: require('./images/lastMail.png'),
    });
};
export const buildPtMailContentImgVar = buildPtMailContentImgVarOrg();
const buildPtMailContentImgVarAsync = async () => {
    return new Promise((resolve, reject) => {
        const localUrlList = buildPtMailContentImgVar();
        const timerImgVarAsync = setInterval(() => {
            const contentUrl1 = localUrlList.contentUrlList[0];
            const contentUrl2 = localUrlList.contentUrlList[1];
            const contentUrl3 = localUrlList.contentUrlList[2];
            if (contentUrl1 && contentUrl3 && contentUrl2 && localUrlList.productPUrl && localUrlList.lastMailUrl) {
                resolve(localUrlList);
                clearTimeout(timerImgVarAsync);
            }
        }, 500);
    });
};
export const transSignSingle = (htmlString) => {
    if (!htmlString) {
        return '';
    }
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');
    const signatureEntElements = doc.querySelectorAll('.mail-signature-ent');
    const signatureElements = doc.querySelectorAll('.mail-signature');
    const resultContainer = document.createElement('div');
    if (signatureEntElements.length > 0) {
        signatureEntElements.forEach(el => {
            resultContainer.appendChild(el.cloneNode(true));
        });
    }
    else if (signatureElements.length > 0) {
        signatureElements.forEach(el => {
            resultContainer.appendChild(el.cloneNode(true));
        });
    }
    else {
        return '';
    }
    return resultContainer.innerHTML;
};
let glb_productPUrl = '';
let glb_lastMailUrl = '';
let contentUrlList0 = '';
let contentUrlList1 = '';
let contentUrlList2 = '';
export const buildPtMailContent = async (version) => {
    const subscribTextData = await edmApi.handleUnsubscribeText('en');
    const subscribText = subscribTextData.text;
    const signature = await mailSigApi.doGetDefaultSign();
    if (!glb_productPUrl) {
        glb_productPUrl = require('./images/product.png');
    }
    if (!glb_lastMailUrl) {
        glb_lastMailUrl = require('./images/lastMail.png');
    }
    if (!contentUrlList0) {
        contentUrlList0 = require('./images/contentP.png');
    }
    if (!contentUrlList1) {
        contentUrlList1 = require('./images/contentP2.png');
    }
    if (!contentUrlList2) {
        contentUrlList2 = require('./images/contentP3.png');
    }
    const contentUrl = [contentUrlList0, contentUrlList1, contentUrlList2][version];
    const productUrl = glb_productPUrl;
    const lastMailUrl = glb_lastMailUrl;
    let nextSignature = '';
    if (signature && signature.enable && signature.content) {
        const signContent = transSignSingle(signature.content);
        nextSignature = mailApi.doTransferSign(signContent);
    }
    const versionVar = ['wmt_effect_dyn_content_1', 'wmt_effect_dyn_content_2', 'wmt_effect_dyn_content_3'][version];
    const dynContent = `<img contenteditable='false' style='pointer-events: none;' src='${contentUrl}' width='840px' />`;
    const res1 = `
      <div>Hi <span class="mce-lx-var mceNonEditable varSpan" contenteditable="false" data-var="wmt_crm_name_2" data-var-show="[姓名2]">[姓名2]</span>,</div>
      <div>I hope this email finds you well.</div>
      <div><div class="mce-lx-var mce-lx-var-nobg mceNonEditable varSpan" contenteditable="false" data-var="${versionVar}" data-var-show="edmPTcontentP0">
      ${dynContent}</div></div>
      <div>I am excited to inform you that we are currently offering a special promotion on our products.If you have any needs, please let me know as soon as possible so I can secure a discounted spot for you.</div>
      <div>Thank you for your attention, and I look forward to hearing  from you soon.</div>
      <div>Best regards,</div>
      <div>${subscribText}</div>
      <div></br></div>
      <div></br></div>
      <div>${nextSignature}</div>
      <div></br></div>
      <div></br></div>
      <div><div class="mce-lx-var mce-lx-var-nobg mceNonEditable varSpan" contenteditable="false" data-var="wmt_quote_recent_open" data-var-show="edmPTlastMail">
      <img src="${lastMailUrl}" width="840px" />
      </div></div>
      <div hadSubscribe='1'></div>
    `;
    const res2 = `
      <div>Hi <span class="mce-lx-var mceNonEditable varSpan" contenteditable="false" data-var="wmt_crm_name_2" data-var-show="[姓名2]">[姓名2]</span>,</div>
      <div>I hope everything is going well for you.</div>
      <div><div class="mce-lx-var mce-lx-var-nobg mceNonEditable varSpan" contenteditable="false" data-var="${versionVar}" data-var-show="edmPTcontentP1">
      ${dynContent}</div></div>
      <div>We are interested in learning more about your purchasing needs and the types of products you are seeking. Please let us know, and we can provide you with our comprehensive product catalog..</div>
      <div><div class="mce-lx-var mce-lx-var-nobg mceNonEditable varSpan" contenteditable="false" data-var="wmt_recent_product_intro" data-var-show='edmPTproductUrl'>
      <img src="${productUrl}" width="840px" /></div></div>
      <div>Thank you for taking the time to review this. I look forward to your prompt reply.</div>
      <div>Best regards,</div>
      <div>${subscribText}</div>
      <div></br></div>
      <div></br></div>
      <div>${nextSignature}</div>
      <div></br></div>
      <div></br></div>
      <div><div class="mce-lx-var mce-lx-var-nobg mceNonEditable varSpan" contenteditable="false" data-var="wmt_quote_recent_open" data-var-show='edmPTlastMail'>
      <img src="${lastMailUrl}" width="840px" /></div></div>
      <div hadSubscribe='1'></div>
    `;
    const res3 = `
      <div>Hi <span class="mce-lx-var mceNonEditable varSpan" contenteditable="false" data-var="wmt_crm_name_2" data-var-show="[姓名2]">[姓名2]</span>,</div>
      <div>I hope everything is going well for you.</div>
      <div><div class="mce-lx-var mce-lx-var-nobg mceNonEditable varSpan" contenteditable="false" data-var="${versionVar}" data-var-show="edmPTcontentP2">
      ${dynContent}</div></div>
      <div>Please let us know your required quantities and any specific needs.We will provide the best possible discounts.</div>
      <div><div class="mce-lx-var mce-lx-var-nobg mceNonEditable varSpan" contenteditable="false" data-var="wmt_recent_product_intro" data-var-show='edmPTproductUrl'>
      <img src="${productUrl}" width="840px" /></div></div>
      <div>Thank you for giving this your attention. I look forward to your response soon.</div>
      <div>Best regards,</div>
      <div>${subscribText}</div>
      <div></br></div>
      <div></br></div>
      <div>${nextSignature}</div>
      <div></br></div>
      <div></br></div>
      <div><div class="mce-lx-var mce-lx-var-nobg mceNonEditable varSpan" contenteditable="false" data-var="wmt_quote_recent_open" data-var-show='edmPTlastMail'>
      <img src="${lastMailUrl}" width="840px" /></div></div>
      <div></br></div>
      <div></br></div>
      <div hadSubscribe='1'></div>
    `;
    return [res1, res2, res3][version];
};
